module.exports = __webpack_public_path__ + "img/T5-C-rc_0.b79bf33f.png";